import { DataModel } from "common/models/utility-models/base-model";

export class MentoringReportsModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedStatus: string = '';
    selectedUploadFilter: string = '';
    selectedYear: string = '';
    selectedQuarter: string = '';
    
}

